import { QuickStartAttributeValue } from "./attributes-mappings";
import { QuickStartTaskId } from "../../pages/quickstart/quickstart-tasks";
import { RolesEnum } from "@/lib/types/roles.types";
import { TOTAL_QUICKSTART_TASKS } from "../../pages/quickstart/quickstart-tasks";

export function quickStartTaskIsCompleted(
	attributeValue: QuickStartAttributeValue | undefined
): boolean {
	if (!attributeValue) return false;
	return attributeValue === "completed" || attributeValue === "skipped";
}

export function taskIsOpen(
	attributeValue: QuickStartAttributeValue | undefined
): boolean {
	if (!attributeValue) return false;
	return attributeValue === "open";
}

export const showQuickstart = (
	role: number | null,
	completedTaskIds: QuickStartTaskId[],
	isSetupIncomplete?: boolean
): boolean => {
	const isAdmin = role !== null && role <= RolesEnum.ADMIN;

	if (!isAdmin) {
		return false;
	}

	if (role === RolesEnum.OWNER && isSetupIncomplete) {
		return true;
	}

	return completedTaskIds.length < TOTAL_QUICKSTART_TASKS;
};
